/**
 * The appearance variations for the card component
 * @public
 */
export const CardAppearances = {
    filled: "filled",
    filledAlternative: "filled-alternative",
    outline: "outline",
    subtle: "subtle"
};
/**
 * Back-compat runtime alias for {@link CardAppearances}.
 * @public
 */
export const CardAppearance = CardAppearances;
/**
 * The orientation variations for the card component
 * @public
 */
export const CardOrientations = {
    horizontal: "horizontal",
    vertical: "vertical"
};
/**
 * Back-compat runtime alias for {@link CardOrientations}.
 * @public
 */
export const CardOrientation = CardOrientations;
/**
 * The focus mode variations for the card component
 * @public
 */
export const CardFocusModes = {
    off: "off",
    noTab: "no-tab",
    tabExit: "tab-exit",
    tabOnly: "tab-only"
};
/**
 * Back-compat runtime alias for {@link CardFocusModes}.
 * @public
 */
export const CardFocusMode = CardFocusModes;
/**
 * Card event names
 * @public
 */
export const CardEventNames = {
    interactiveChanged: "interactive-changed",
    click: "click"
};
//# sourceMappingURL=card.options.js.map